import { Component, Input, OnChanges, SimpleChanges, Output, EventEmitter, ViewChild, OnInit, OnDestroy } from "@angular/core";
import { NgbDropdown } from "@ng-bootstrap/ng-bootstrap";
import { Subscription } from "rxjs";
import { ImpersonationService } from "../../../auth/apigee/impersonation.service";

export class ChartDropdownOption {
    public text: string;
    public value: any;
}

@Component({
    selector: 'chart-dropdown',
    templateUrl: './chartDropdown.component.html',
    standalone: false
})
export class ChartDropdownComponent implements OnChanges, OnInit, OnDestroy {
    @ViewChild(NgbDropdown) private dropdownOptions: NgbDropdown;

    @Input() public options: ChartDropdownOption[] = [];
    public selectedOption: ChartDropdownOption;
    @Output() public onSelectedOptionChanged: EventEmitter<ChartDropdownOption> = new EventEmitter<ChartDropdownOption>();
    private authChangedSubscription: Subscription;
    private resetSelectorFlag: boolean = true;

    constructor(private impersonationService: ImpersonationService) {

    }

    public optionSelected(option: ChartDropdownOption): void {
        this.selectedOption = option;
        this.dropdownOptions.close();
    }

    public get isOpen(): boolean {
        return this.dropdownOptions.isOpen();
    }

    public ngOnChanges(changes: SimpleChanges): void {
        let selectedOptionChanges = changes["selectedOption"]
        if (selectedOptionChanges) {
            this.onSelectedOptionChanged.emit(selectedOptionChanges.currentValue);
        }

        let optionsChanges = changes["options"];
        if (optionsChanges && optionsChanges.currentValue && optionsChanges.currentValue.length > 0) {
            if (this.resetSelectorFlag) {
                this.resetSelectorFlag = false;
                if (this.impersonationService.isImpersonating) {
                    let impersonatedUserData = optionsChanges.currentValue.find(x => x.text == this.impersonationService.getChartUserDisplayName());
                    if (impersonatedUserData) {
                        this.selectedOption = impersonatedUserData;
                    } else {
                        this.selectedOption = optionsChanges.currentValue[0];
                    }
                } else {
                    this.selectedOption = optionsChanges.currentValue[0];
                }
            } else {
                if (this.selectedOption) {
                    let previousOption = optionsChanges.currentValue.find(x => x.text == this.selectedOption.text);
                    this.selectedOption = previousOption || optionsChanges.currentValue[0];
                }
                else this.selectedOption = optionsChanges.currentValue[0];
            }
        } else {
            this.selectedOption = null;
        }
    }

    public ngOnInit() {
        this.authChangedSubscription = this.impersonationService.impersonationChanged.subscribe(() => { this.resetSelectorFlag = true; })
    }

    public ngOnDestroy() {
        if (this.authChangedSubscription) this.authChangedSubscription.unsubscribe();
    }
}
